import { render, staticRenderFns } from "./Datos_User.vue?vue&type=template&id=66ee22a7&scoped=true&"
import script from "./Datos_User.vue?vue&type=script&lang=js&"
export * from "./Datos_User.vue?vue&type=script&lang=js&"
import style0 from "./Datos_User.vue?vue&type=style&index=0&id=66ee22a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee22a7",
  null
  
)

export default component.exports